// TODO_R: move file into src/types folder
// TODO_R: give proper name to this file

import { FtTokenMetadata, NftTokenMetadata } from '../types';

type Signer = {
  address: string;
  approved: boolean;
};

export interface FTAsset {
  address: string;
  symbol: string;
  decimals: number;
  ref: string;
  metadata?: FtTokenMetadata;
}

export interface NFTAsset {
  address: string;
  name: string;
  ref: string;
  token?: string;
  metadata?: NftTokenMetadata;
}

export type Menu = {
  icon: any;
  text: string;
};

export type Transaction = {
  tokenIcon: any;
  currentAmount: string;
  totalAmount?: string;
  type1: string;
  type2: string;
  selectType: number;
  start?: number;
  end?: number;
  to: string;
  status: string;
  remaining: number;
  owner: number;
  signers?: Signer[];
  progress: number;
  actions: number[];
  tokenSymbol?: string;
  proposal?: Proposal;
  token?: string;
  claimed: string;
  claimedProgress: number;
};

type Proposal = {
  id: number;
  approval_votes: number;
  cancellation_votes: number;
  creator: string;
  executed: boolean;
  votes: Table;
};

export enum StxChain {
  STX_TESTNET_CHAIN = 'stx:testnet',
  STX_MAINNET_CHAIN = 'stx:mainnet',
}

type Table = {
  handle: string;
};

export enum TransactionStatus {
  REJECTED = 'REJECTED',
  EXECUTED = 'EXECUTED',
  EXECUTION = 'EXECUTION',
  QUEUED = 'QUEUED',
  EXECUTION_ERRORED = 'EXECUTION_ERRORED',
  SIGNED = 'SIGNED',
}

export interface ICreateSignature {
  owner: string;
  ownerId: string;
  signedTransactionHex: string;
}

export interface IBaseCreateTransaction {
  multiSigId: string;
  rawTransactionHex: string;
}

export interface ISignature extends ICreateSignature {
  index: number;
  create_time: Date;
}

export interface ICreateTransaction extends IBaseCreateTransaction {
  signedTransactionHex?: string;
  notes?: string;
}

export interface IBaseTransaction extends IBaseCreateTransaction {
  creator: string;
  creatorId: string;
  txId?: string;
  multiSigId: string;
  multiSig: string;
  create_time?: Date;
  update_time?: Date;
  status: TransactionStatus;
  signatures: ISignature[];
  network: StxChain;
  transactionData?: object;
  nonce: string;
  retry?: number;
  type: string;
  error?: {
    error: string;
    reason: string;
    txid: string;
  };
  signedTransactionHex?: string;
}

export interface ITransaction extends IBaseTransaction {
  _id: string;
  notes?: string;
}
